import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const attachPurchaser = createAction(ACTION.ATTACH_PURCHASER.REQUEST, (userId) => ({userId}));
export const detachPurchaser = createAction(ACTION.DETACH_PURCHASER.REQUEST, (userId) => ({userId}));
